import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Box, Typography } from '@mui/material';

import { FBoxContainer } from '../../../components/base';
import { FORTA_BLUE, FORTA_SUCCESS } from '../../../utils/colors';
import CardLoader from './CardLoader';
import ActionRequiredCard from './ActionRequiredCard';
import { ActionRequiredItemEnum, BTSessionStatus } from '../../../constants';

import type { RootState } from '../../../store';

function BCBASessionSection() {
  const { loading, list: sessions } = useSelector((state: RootState) => state.sessions);

  const filteredSessions = useMemo(() => {
    return sessions.filter(
      (session) => session.status === BTSessionStatus.AwaitingGuardianSignature,
    );
  }, [sessions]);

  return (
    <FBoxContainer
      sx={{ flexGrow: 0, minHeight: '35vh', textAlign: 'left', height: 450 }}
      contentStyle={{
        pr: filteredSessions?.length > 3 ? 1 : 2,
      }}
    >
      <Typography sx={{ color: FORTA_BLUE.primary, fontSize: 18, fontWeight: 500 }}>
        Direct sessions - Pending guardian signature
      </Typography>
      <Box
        sx={{
          overflowY: 'auto',
          height: 360,
          mt: 2.5,
        }}
      >
        {loading ? (
          Array.from({ length: 3 }).map((_, i) => <CardLoader sx={{ mr: 1 }} key={i} />)
        ) : filteredSessions?.length === 0 ? (
          <Box
            sx={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
          >
            <CheckCircleIcon sx={{ color: FORTA_SUCCESS }} />
            <Typography ml={0.5}>You&apos;re all caught up!</Typography>
          </Box>
        ) : (
          filteredSessions.map((session) => (
            <ActionRequiredCard
              key={session.id}
              item={session}
              dateStart={moment(session.date_start).toISOString()}
              type={ActionRequiredItemEnum.Session}
              id={session.id ?? ''}
              status={session.status}
              duration={session.expected_duration}
            />
          ))
        )}
      </Box>
    </FBoxContainer>
  );
}

export default BCBASessionSection;
